<template>
  <div>
    <ProcessGroup
      :selectedItems="selected_requests"
      type="moveAllPendingRequests"
      @getData="reloadPage"
    />
    <div v-if="!this.$store.state.recievedLoading" style="margin-top: 40px">
      <div v-if="$store.state.views === 'cards'">
        <div v-if="this.$store.state.recievedData.length > 0">
          <RequestsCard
            :CardData="this.$store.state.recievedData"
            v-if="!this.$store.state.recievedLoading"
            @pageCount="handlePageNumber"
            @back="handleBack"
          />
          <div>
            <LoadingMore v-if="loadMoreData" style="margin: 40px" />
          </div>
        </div>
        <div v-else>
          <div>
            <button
              @click="handleBack"
              style="
                width: 70px;
                height: 40px;
                border-radius: 5px;
                margin: 50px;
                color: white;
                background-color: #441545;
                direction: ltr;
              "
            >
              رجوع
            </button>
          </div>
          <div class="noData">لا يوجد بيانات</div>
        </div>
      </div>
      <div v-else-if="$store.state.views === 'table'">
        <table-component
          :showSelect="false"
          itemKey="id"
          :headers="headers"
          :pagination="this.$store.state.pagination"
          :limit="$store.state.counterOfShow"
          :items="this.$store.state.tableData"
          :loading="loading"
          @refresh="getTableData"
          v-model="page"
        >
          <template slot="item.quality_notes" slot-scope="props">
            <span v-if="!props.item.quality_notes"></span>
            <v-tooltip bottom v-else>
              <template v-slot:activator="{ on }">
                <span v-on="on">{{
                  props.item.quality_notes.length > 7
                    ? props.item.quality_notes.substring(0, 7) + "..."
                    : props.item.quality_notes
                }}</span>
              </template>
              <div class="font-weight-bold">{{ props.item.quality_notes }}</div>
            </v-tooltip>
          </template>

          <template slot="item.req_product_type" slot-scope="props">
            <span v-if="props.item.req_product_type !== 'لا_يوجد'" style="font-family: Dintext">{{ props.item.req_product_type }}</span>
            <span v-else style="color: red;font-family: Dintext">{{ props.item.req_product_type }}</span>
          </template>

          <template slot="item.agent_class_note" slot-scope="props">
            <classification-cell :label="props.item.class_id_agent_text" :color="props.item.class_id_agent_color" :name="props.item.agent_name" :note="props.item.agent_notes" :date="props.item.comment_date" />
          </template>
          <template slot="item.cs_class_note" slot-scope="props">
            <classification-cell :label="props.item.class_id_cs_text" :color="props.item.class_id_cs_color" :name="props.item.customer_service_name" :note="props.item.cs_note" :date="props.item.customer_service_note_date" />
          </template>
        </table-component>
      </div>

      <div v-else-if="$store.state.views === 'default'">
        <div v-if="this.$store.state.recievedData.length > 0" style="margin-top: 40px">
          <DefaultView
            :CardData="this.$store.state.recievedData"
            @back="handleBack"
            @pageCount="handlePageNumber"
          />
          <div>
            <LoadingMore v-if="loadMoreData" style="margin: 40px" />
          </div>
        </div>
      </div>
    </div>
    <div
      style="
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 40px;
      "
      v-else
    >
      <LoadingMore />
    </div>
    <FilterDialogInAdmin pageName="received" />
  </div>
</template>

<script>
import Axios from "axios";
import RequestsCard from "@/components/Charts/RequestsCard.vue";
import LoadingMore from "@/components/Charts/LoadingMore.vue";
import { formatDate } from "@/mixins/formatDate";
import { SourceValue } from "@/mixins/sourceValue";
import ProcessGroup from "@/views/admin/Requests/MoveToNew/ProcessGroup.vue";
import FilterDialogInAdmin from "@/components/Charts/FilterDialogInAdmin.vue";
import DefaultView from "@/components/Base/DefaultView.vue";
import ClassificationCell from "@/components/Base/ClassificationCell.vue";
import {axiosInstance} from "@/axios/config";

export default {
  name: "AdminSupport",
  components: {
    FilterDialogInAdmin,
    ProcessGroup,
    RequestsCard,
    LoadingMore,
    DefaultView,
    ClassificationCell,
  },

  data() {
    return {
      page: 1,
      loading: false,
      copySupportRequests: [],
      loadMoreData: false,

      selected_products_list: [],
      loadingData: false,
      selected_requests: [],
      allGetData: [],
      headers: [
        { text: "تاريخ الطلب", value: "تاريخ الطلب", width: "107px", align: "center" },
        { text: "نوع الطلب", value: "req_product_type", align: "center" },
        { text: "عميل", value: "عميل", align: "center" },
        { text: "الجوال", value: "الجوال", align: "center" },
        { text: "حاله الطلب", value: "حاله الطلب", width: "120px", align: "center" },
        {
          text: "مصدر المعامله",
          value: "source_text",
          align: "center",
        },
        { text: "الأستشاري", value: "agent_class_note", width: "180px", align: "center", sortable: false },
        { text: "خدمة العملاء", value: "cs_class_note", width: "180px", align: "center", sortable: false },
        {
          text: "ملاحظه الجوده",
          value: "quality_notes",
          align: "center",
          width: "110px",
        },
        {
          text: "التاريخ عند الاستشاري",
          value: "التاريخ عند الاستشاري",
          width: "115px",
          align: "center",
        },
        {
          text: "استلام الجودة",
          value: "هل تم استلامه من قبل الجوده",
          align: "center",
        },
        { text: "تم التحديث ", value: "تم التحديث في", width: "108px", align: "center" },
      ],
    };
  },

  watch: {
    "$store.state.selectedOrderById": {
      immediate: true,
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          console.log("newValue", newValue);
          this.$store.state.tableData = [];
          this.getAllRequests();
        }
      },
    },
    page(val) {
      if (this.$store.state.isSearch === false) {
        this.getTableData(val);
      } else {
        this.searchRequest(val, "table");
      }
    },

    selected_requests(val) {
      this.selectedItems = val;
      this.$emit("requests", val);
    },

    "$store.state.counterOfShow": {
      handler(newval, oldvalue) {
        if (newval != oldvalue) {
          this.getTableData(this.page);
        }
      },
    },

    $route: {
      immediate: true,
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.$store.state.counterOfShow = 10;
        }
      },
    },
  },

  methods: {
    reloadPage() {
      this.$store.state.recievedData = [];
      this.$store.state.tableData = [];
      this.allGetData = [];
      this.copySupportRequests = [];
      this.$store.state.isSearch = false;
      this.page = 1;
      this.getAllRequests(1);
      this.$store.state.startElement = [];
    },
    handleBack() {
      this.$store.state.recievedData = [];
      this.$store.state.tableData = [];
      this.$store.state.recievedLoading = true;
      this.$store.state.isSearch = false;
      this.$store.state.back = false;
      this.getAllRequests(1, "back");
    },
    handlePageNumber(val) {
      if (this.$store.state.isSearch === false) {
        this.getAllRequests(val);
      } else {
        this.searchRequest(val);
      }
    },

    getProductType() {
      let url = "/customer/SelectedProduct";
      axiosInstance.get(url).then((res) => {
        this.selected_products_list = res.data.payload;
      });
    },
    searchRequest(page, type) {
      this.loading = true;

      if (type === "table") {
        this.$store.state.tableData = [];
      }

      if (page > 1 || type === "table") {
        this.$store.state.bodySearch.delete("page");
        this.$store.state.bodySearch.append("page", page);
        const selectedOrderBy =
          this.$store.state.selectedOrderById || "created_at";

        let url = `${this.$store.state.url}/v2/employee/Requests/search?type=received&order_by=${encodeURIComponent(
          selectedOrderBy
        )}`;
        Axios.post(url, this.$store.state.bodySearch, {
          headers: this.request_headers(),
        }).then((res) => {
          this.$store.state.pagination = {
            limit: 3,
            count: res.data.payload.searched,
          };
          let response = res.data.payload.data;
          response.map((item) => {
            if (item.length === 0) {
              this.loading = false;
            }
            this.setTbData(item);
            item["starChecked"] = false;
            return item;
          });

          this.$store.state.recievedSearch.push(...response);
          this.removeDublicate(this.$store.state.recievedSearch);
          this.loading = false;
        });
      }
    },

    getTableData(count = 1) {
      this.$store.state.tableData = [];
      this.loading = true;
      const selectedOrderBy =
        this.$store.state.selectedOrderById || "created_at";
      Axios.get(
        `${this.$store.state.url}/v2/employee/Requests?type=received&page=${count}&per_page=${this.$store.state.counterOfShow}&order_by=${encodeURIComponent(
          selectedOrderBy
        )}`,
        { headers: this.request_headers() }
      ).then((res) => {
        res.data.payload.data.map((item) => {
          this.setTbData(item);
        });
        this.loading = false;
      });
    },

    setTbData(items) {
      console.log(items.class_id_agent_text, items);
      this.$store.state.tableData.push({
        id: items.id,
        "تاريخ الطلب": items.req_date,
        req_product_type: this.selected_products_list.find(item => item.id === items.req_product_type)?.value || "لا_يوجد",        "استشاري المبيعات": items.user?.name,
        عميل: items.customer?.name,
        الجوال: items.customer?.mobile,
        "حاله الطلب": items.status,
        "مصدر المعامله": "items.source_text",
        /*"مصدر المعامله": SourceValue(items.source),*/
        source_text: items.source_text,
        class_id_agent_text: items.class_id_agent_text ?? null,
        class_id_agent_color: items.class_id_agent_color ?? null,
        agent_name: items.agent_name ?? items.user?.name ?? null,
        agent_notes: items.agent_notes ?? items.agent_note ?? items.comment ?? null,
        comment_date: items.comment_date ?? null,
        class_id_cs_text: items.class_id_cs_text ?? null,
        class_id_cs_color: items.class_id_cs_color ?? null,
        customer_service_name: items.customer_service_name ?? items.customer_service?.name ?? null,
        cs_note: items.cs_note ?? items.customer_service_note ?? null,
        customer_service_note_date: items.customer_service_note_date ? formatDate(items.customer_service_note_date) : (items.customer_service_note_date ?? null),
        quality_notes: items.quality_notes,
        "التاريخ عند الاستشاري": formatDate(items.agent_date),
        "هل تم استلامه من قبل الجوده": this.returnValue(items.highlight_received),
        "تم التحديث في": items.updated_at ? formatDate(items.updated_at) : "",
      });
    },

    returnValue(item) {
      if (!item) {
        return "لا";
      } else {
        return "نعم";
      }
    },

    getAllRequests(count = 1) {
      if (
        this.$store.state.recievedData.length === 0 &&
        this.copySupportRequests.length === 0
      ) {
        this.$store.state.recievedLoading = true;
      }
      this.loadMoreData = true;
      const selectedOrderBy =
        this.$store.state.selectedOrderById || "created_at";
      Axios.get(
        `${this.$store.state.url}/v2/employee/Requests?type=received&page=${count}&per_page=${this.$store.state.counterOfShow}&order_by=${encodeURIComponent(
          selectedOrderBy
        )}`,
        { headers: this.request_headers() }
      )
        .then((res) => {
          this.$store.state.recievedLoading = false;
          let response = res.data.payload.data;
          response.map((item) => {
            this.setTbData(item);
            item["starChecked"] = false;
            return item;
          });

          this.$store.state.pagination = {
            limit: 3,
            count: res.data.payload.count_of_received,
          };
          this.allGetData.push(...response);
          this.removeDublicate(this.allGetData);
          this.copySupportRequests.push(...response);
        })
        .catch((err) => {
          this.loadingData = false;
          this.loadMoreData = false;
        })
        .finally(() => {
          this.loadMoreData = false;
          this.loadingData = false;
        });
    },

    removeDublicate(array) {
      let uniqueArray = array.filter((item, index) => {
        return (
          index ===
          array.findIndex((obj) => {
            return obj.id === item.id; // Compare based on the 'id' property
          })
        );
      });
      this.$store.state.recievedData = uniqueArray;
    },
  },

  created() {
    this.$store.state.recievedData = [];
    this.$store.state.tableData = [];
    this.$store.state.back = false;
    this.$store.state.bodySearch = new FormData();
    this.$store.state.isSearch = false;

    this.selected_products_list = this.$store.state.selected_products;
    this.$store.state.startElement = [];
    this.getAllRequests();
  },
};
</script>

<style>
.noData {
  display: flex;
  justify-content: center;
  font-size: 22px;
  color: #3f0e40;
  margin-top: 70px;
  font-weight: bold;
}
</style>
